<app-header></app-header>

<!--====== PAGE TITLE PART START ======-->
<div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i" 
         [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <span class="assurance">{{slide.type}}</span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" [src]="slide.imgIcon" alt="">
                            </div>
                            <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title" *ngIf="title!=''">{{title}}</span>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="getDevisAutre()">Obtenir un devis</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="case-studies-area">
  <div class="container">
    
    <!-- Barre de progression -->
    <div class="row" *ngIf="currentStep > 0 && currentStep < 4">
      <div class="devis">
        <div class="title">Mon devis</div>
        <img src="assets/images/stopwatch.svg" alt="">
      </div>
      <div class="temps">
        <span class="barre-temps"></span>
        <span class="message-temps">En quelques minutes</span>
      </div>
    </div>

    <!-- <div class="progress" *ngIf="currentStep > 0 && currentStep < 3">
      <div class="progress-bar progress-bar-striped progress-bar-animated" 
           [style.width.%]="getProgressPercentage()"></div>
      <span class="text-changement">{{getProgressText()}}</span>
    </div> -->

    <div class="latest-services-area">
      <div class="container">
        <div class="formulaire" *ngIf="currentStep >= 0">
          <form [formGroup]="simulationMrpForm" class="form-wizard-container">
            
            <!-- Page d'accueil -->
            <div class="welcome-step" *ngIf="currentStep === 0">
              <div class="welcome-content">
                <h1>Bonjour ! Je suis Marilyne</h1>
                <h2>Je suis là pour vous aider</h2>
                <p class="welcome-description">
                  Obtenez votre devis d'assurance multirisque professionnelle en quelques minutes seulement.
                  Je vais vous guider étape par étape pour protéger votre entreprise et vos biens professionnels.
                </p>
                <button class="cta-button" (click)="nextStep()">
                  C'est parti !!
                </button>
              </div>
            </div>

            <!-- Étape 1: Informations sur l'entreprise -->
            <div class="step-container" *ngIf="currentStep === 1">
              <div class="step-header">
                <h2>Informations sur l'entreprise</h2>
                <p class="step-subtitle">Renseignez les informations de votre entreprise</p>
                <p class="step-note">* montant en CFA XOF</p>
                <div class="step-progress">Étape 1 sur 2</div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="text" formControlName="nomEntreprise" placeholder="Dénomination" noAutocomplete>
                    <img class="img-form" popover="Dénomination" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/icon-personne-morale.svg" alt="">
                    <i class="barre"></i>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="text" formControlName="adresse" placeholder="Adresse" noAutocomplete>
                    <img class="img-form" popover="Adresse" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/icon-adresse.svg" alt="">
                    <i class="barre"></i>
                  </div>
                </div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="email" formControlName="email" placeholder="Courriel *" noAutocomplete>
                    <img class="img-email" popover="Email" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/icon-email.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  <div *ngIf="simulationMrpForm.get('email').errors">
                      <div
                        *ngIf="simulationMrpForm.get('email').errors.required && (simulationMrpForm.get('email').dirty || simulationMrpForm.get('email').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                      <div *ngIf="simulationMrpForm.get('email').errors.pattern">
                        <div class="text-red">
                          Email est invalide
                        </div>
                      </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box sinistre mt-30">
                    <input type="tel" 
                           formControlName="telephone"
                           ng2TelInput 
                           [ng2TelInputOptions]="{initialCountry: currentFiliale?.code}"
                           placeholder="Numéro de téléphone *"
                           (focus)="isFocus=true" 
                           (blur)="isFocus=false; hasError($event, 'telephone', 'simulationMrpForm');autoSave()"
                           (ng2TelOutput)="getNumber($event, 'telephone', 'simulationMrpForm')"
                           (intlTelInputObject)="telInputObject($event)" 
                           (countryChange)="onCountryChange($event)" noAutocomplete>
                  </div>

                  <div *ngIf="simulationMrpForm.get('telephone').errors">
                      <div
                        *ngIf="simulationMrpForm.get('telephone').errors.required && (simulationMrpForm.get('telephone').dirty || simulationMrpForm.get('telephone').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                    <!-- <div class="text-red"
                      *ngIf="simulationMrpForm.get('telephone').value && isFocus===false && hasPhoneError">
                      Le champs téléphone est invalide
                    </div> -->
                </div>
              </div>

              <!-- <div class="formulaire">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Qualité du proposant</div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let qualite of listQualiteProposant">
                      <input type="radio" [id]="qualite.value" [value]="qualite.value" 
                             formControlName="qualiteProposant" 
                             (change)="onQualiteProposantChange()" />
                      <label [for]="qualite.value">{{qualite.name}}</label>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="formulaire form-grid">
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <ng-select  (change)="onQualiteProposantChange()" formControlName="qualiteProposant" 
                            clearAllText="Effacer tout" 
                            notFoundText="Aucun élément trouvé"
                            [items]="listQualiteProposant" 
                            bindLabel="name" 
                            bindValue="value"
                            placeholder="Qualité du proposant">
                  </ng-select>
                  <span class="input-icon">
                    <img src="assets/images/pays-de-residence.svg" alt="">
                  </span>
                </div>
                </div>

                <div class="col-lg-6 col-sm-6 pr-0">  
                  <div class="input-box">
                    <input type="text" formControlName="services" placeholder="Type de services">
                    <img class="img-form" popover="Type de services" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                </div>

              </div>

              <div class="form-grid formulaire">
                 <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="text" 
                         formControlName="valeurBatiment" 
                         placeholder="Valeur du Bâtiment"
                         (input)="onMontantInput($event, 'valeurBatiment')">
                  <img class="img-form" popover="Valeur du Bâtiment" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/icon-valeur-locative.svg" alt="">
                  <i class="barre"></i>
                </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                    <div class="input-box" *ngIf="simulationMrpForm.get('qualiteProposant')?.value === 'Locataire'">
                        <input type="text" 
                                  formControlName="loyer" 
                                  placeholder="Loyer mensuel"
                                  (input)="onMontantInput($event, 'loyer')">
                        <img class="img-form" popover="Loyer mensuel" placement="top" triggers="mouseenter:mouseleave"
                              src="assets/images/icon-valeur-locative.svg" alt="">
                        <i class="barre"></i>
                      </div>
              </div>
              </div>

              <!-- <div class="form-grid formulaire" >
               
              </div> -->

              <div class="step-navigation">
                <button class="btn-back" (click)="currentStep = 0">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 2: Choix des garanties -->
            <div class="step-container" *ngIf="currentStep === 2">
              <div class="step-header">
                <h2>Choix des garanties</h2>
                <p class="step-subtitle">Sélectionnez les garanties adaptées à votre activité</p>
                <div class="step-progress">Étape 2 sur 2</div>
              </div>

              <!-- Types de construction -->
              <div class="formulaire">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Types de construction</div>
                    <div class="col-md-4 col-sm-6 col-xs-12" *ngFor="let type of listTypesConstruction">
                      <input type="radio" [id]="type.value" [value]="type.value" formControlName="typesConstruction" />
                      <label [for]="type.value">{{type.name}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Moyens de protection contre le vol -->
              <div class="formulaire">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Avez-vous des moyens de protection contre le vol ?</div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let protection of listOuiNon">
                      <input type="radio" [id]="'protection_' + protection.value" [value]="protection.value" formControlName="moyenProtection" />
                      <label [for]="'protection_' + protection.value">{{protection.name}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Dispositif informatique -->
              <div class="formulaire">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Avez-vous un dispositif informatique important (serveurs, logiciels de grande valeur)?</div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let dispositif of listOuiNon">
                      <input type="radio" [id]="'dispositif_' + dispositif.value" [value]="dispositif.value" formControlName="dispositifInformatique" />
                      <label [for]="'dispositif_' + dispositif.value">{{dispositif.name}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Glaces et vitres -->
              <div class="formulaire">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Y-a-t-il des glaces ou des vitres de plus de 5 m² de surface unitaire ?</div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let vitre of listOuiNon">
                      <input type="radio" [id]="'vitre_' + vitre.value" [value]="vitre.value" formControlName="vitreGlaces" />
                      <label [for]="'vitre_' + vitre.value">{{vitre.name}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Voir le récapitulatif</button>
              </div>
            </div>

            <!-- Récapitulatif -->
            <div class="step-container_2" *ngIf="currentStep === 3">
              <div class="step-header">
                <h2>Récapitulatif de votre demande d'assurance multirisque professionnelle</h2>
                <p class="step-subtitle">Vérifiez vos informations avant de finaliser</p>
              </div>

              <div class="recap-form-container">
                <div class="mesImage">
                  <div class="imgLogo">
                    <img src="assets/images/logo.png" alt="Logo Inclusive Guarantee">
                  </div>
                </div>
                
                <div class="info-devis">
                  <div class="proposition">
                    <div class="pro-title">Demande d'assurance multirisque professionnelle</div>
                    <div class="sub-title">{{numeroSous}}</div>
                  </div>
                  
                  <div class="row">
                    <!-- Informations entreprise -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations sur l'entreprise</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Numéro</div>
                            <div class="col-7 value">{{numeroSous}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Dénomination</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('nomEntreprise')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Adresse</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('adresse')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Email</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('email')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Téléphone</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('telephone')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Qualité proposant</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('qualiteProposant')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Type de services</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('services')?.value}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Informations bâtiment et garanties -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations bâtiment et garanties</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Référence</div>
                            <div class="col-7 value">{{refPro}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Valeur bâtiment</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('valeurBatiment')?.value}} CFA</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="simulationMrpForm?.get('loyer')?.value">
                            <div class="col-5 name">Loyer mensuel</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('loyer')?.value}} CFA</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Type construction</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('typesConstruction')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Protection vol</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('moyenProtection')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Dispositif informatique</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('dispositifInformatique')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Glaces/Vitres > 5m²</div>
                            <div class="col-7 value">{{simulationMrpForm?.get('vitreGlaces')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Date de demande</div>
                            <div class="col-7 value">{{newDate | date:'dd/MM/yyyy'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="description-ass">
                    Cette demande d'assurance multirisque professionnelle sera traitée par nos équipes dans les plus brefs délais. 
                    Vous recevrez une confirmation par email avec les détails de votre couverture.
                  </div>
                  
                  <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Demande d'assurance multirisque professionnelle
                    </div>
                    <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Date émission : {{newDate | date:'dd/MM/yyyy'}} - E-MAIL : contact&#64;inclusiveguarantee.fr
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">
                  <!-- <i class="fa fa-arrow-left"></i> -->
                  Retour
                </button>
                <button type="button" class="btn-continue final-btn" [disabled]="sendingRequest" (click)="saveData()">
                  <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequest"></i>
                  <span *ngIf="!sendingRequest">Finaliser la souscription</span>
                  <span *ngIf="sendingRequest">Traitement en cours...</span>
                </button>
              </div>
            </div>

            <!-- Étape succès -->
            <div class="step-container" *ngIf="currentStep === 4">
              <div class="success-auto">
                <div class="icon-succes">
                   <img width="10%" src="/assets/images/verifier.png" alt="" srcset="">
                </div>
                <!-- <div class="message-success">
                  Votre demande d'assurance multirisque professionnelle a été enregistrée avec succès !
                  <span>Numéro de référence : {{numeroSous}}</span>
                  <span>Nos équipes vous contacteront dans les plus brefs délais.</span>
                </div> -->
                <div class="message-success">
                  Votre demande a été soumise avec succès. Vous recevrez un devis sous 48h. Merci pour la confiance.
                  <span>L'équipe d'Inclusive Guarantee</span>
                </div>
                <button class="btn-success" (click)="resetForm()">
                  <span>Nouvelle demande</span>
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>